import React from 'react';
import { Shield, Zap, EyeOff } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function NEAMethod() {
  return <section className="py-24 md:py-32 bg-teal text-white relative overflow-hidden" data-id="element-135">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-136">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full border border-white/20" data-id="element-137"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-white/30" data-id="element-138"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full border border-white/40" data-id="element-139"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10" data-id="element-140">
        <div className="text-center mb-16" data-id="element-141">
          <FadeIn data-id="element-142">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 text-amber mb-6 backdrop-blur-sm border border-white/20" data-id="element-143">
              <Shield size={32} data-id="element-144" />
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-145">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-146">
              El Método de Resiliencia Activa (N.E.A.)
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-147">
            <p className="text-xl md:text-2xl text-teal-100 max-w-3xl mx-auto leading-relaxed" data-id="element-148">
              En lugar de intentar cambiar al acosador, cambiamos el
              "combustible" que recibe.
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-16" data-id="element-149">
          <FadeIn delay={0.3} data-id="element-150">
            <div className="bg-teal-dark/50 p-8 rounded-2xl border border-teal-light/30 backdrop-blur-sm h-full" data-id="element-151">
              <div className="w-12 h-12 rounded-full bg-amber/20 flex items-center justify-center text-amber mb-6" data-id="element-152">
                <EyeOff size={24} data-id="element-153" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-154">Objetivo Aburrido</h3>
              <p className="text-teal-100 leading-relaxed" data-id="element-155">
                Este sistema enseña a tu hijo a volverse un "objetivo aburrido"
                mediante respuestas de estatus neutro.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-156">
            <div className="bg-teal-dark/50 p-8 rounded-2xl border border-teal-light/30 backdrop-blur-sm h-full" data-id="element-157">
              <div className="w-12 h-12 rounded-full bg-amber/20 flex items-center justify-center text-amber mb-6" data-id="element-158">
                <Zap size={24} data-id="element-159" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-160">Lenguaje de Poder</h3>
              <p className="text-teal-100 leading-relaxed" data-id="element-161">
                Entrenamiento en lenguaje corporal de poder que proyecta
                seguridad sin necesidad de confrontación física.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-162">
            <div className="bg-teal-dark/50 p-8 rounded-2xl border border-teal-light/30 backdrop-blur-sm h-full" data-id="element-163">
              <div className="w-12 h-12 rounded-full bg-amber/20 flex items-center justify-center text-amber mb-6" data-id="element-164">
                <Shield size={24} data-id="element-165" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-166">Neutralización Total</h3>
              <p className="text-teal-100 leading-relaxed" data-id="element-167">
                Cuando el acosador no obtiene lágrimas, miedo ni rabia, busca
                otra víctima. El ciclo se rompe.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}